































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { SessionGettersReturns, SessionActionsKeys, SessionActionsPayload } from '../../store/types/session';
import CreateSession from './CreateSession.vue';
import SessionContext from './SessionContext.vue';
import { BoardGettersReturns } from '@/store/types/board';
import { RootGettersReturns } from '@/store/types';

@Component({
  components: {
    CreateSession,
    SessionContext,
  },
})
export default class SessionList extends Vue {
  @Prop(Number) selectedBoard!: number | null;
  @Prop(Array) boardFilter!: RootGettersReturns['boardFilter'];
  @Prop(Boolean) selectedOnly?: boolean;
  @Getter sessionList!: SessionGettersReturns['sessionList'];
  @Getter boardList!: BoardGettersReturns['boardList'];
  @Getter favorites!: BoardGettersReturns['favorites'];

  @Action(SessionActionsKeys.LOAD_SESSION) loadSession!: (payload: SessionActionsPayload['LOAD_SESSION']) => void;

  get sessions() {
    if (this.selectedBoard) {
      return this.sessionList.filter(s => s.board.id === this.selectedBoard);
    } else if (this.boardFilter.length) {
      return this.sessionList.filter(s =>
        this.boardList
          .filter(b => b.labels.map(l => l.id).some(id => this.boardFilter.includes(id)))
          .map(b => b.id)
          .includes(s.board.id)
      );
    } else {
      return this.sessionList;
    }
  }

  @Emit('selectedSession')
  openSession(id: number) {
    this.loadSession(id);
  }
}
